import Welcome from "./Merch/Welcome";
import LaunchOne from "./Merch/LaunchOne";
import LaunchTwo from "./Merch/LaunchTwo";

export default function Merch() {
  return (
    <div>
      <Welcome />
      <LaunchOne />
      <LaunchTwo />
    </div>
  );
}
